<img src="assets/img/logo_big.svg" alt="Logo der Österreichischen Apothekerkammer"/>
<p>{{"BIOMETRIC_ACCESS.MESSAGE" | translate}}</p>
<div class="error-text">{{ errorString | translate }}</div>
<app-button (click)="retry()" label="{{'BIOMETRIC_ACCESS.BUTTON' | translate}}"></app-button>

